import { mixins, styled } from '@bob/library'

export type ButtonWrapperProps = {
  isSticky: boolean
}
export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  text-align: center;
  ${mixins.margin.top(50)}
  background: ${mixins.colors.grayWhite};
  border-top: ${({ isSticky }) => (isSticky ? `1px solid ${mixins.colors.grayLight}` : '0')};
`
export const Button = styled.button`
  ${mixins.cta.tertiary('blue')}
`
